
import {
  FETCHING_HUB_STREAMS_REQUEST, FETCHING_HUB_STREAMS_SUCCEEDED, FETCHING_HUB_STREAMS_FAILED,
  FETCHING_STREAM_REQUEST, FETCHING_STREAM_SUCCEEDED, FETCHING_STREAM_FAILED,
  FETCHING_GROUP_REQUEST, FETCHING_GROUP_SUCCEEDED, FETCHING_GROUP_FAILED,
  INVALIDATE_STREAM, INVALIDATE_GROUP, UPLOAD_ASSET_REQUEST,
  FETCHING_STREAM_ASSETS_SEARCH_REQUEST, FETCHING_STREAM_ASSETS_SEARCH_SUCCEEDED, FETCHING_STREAM_ASSETS_SEARCH_FAILED,
  FETCHING_SEARCH_STREAMS_REQUEST, FETCHING_SEARCH_STREAMS_SUCCEEDED, FETCHING_SEARCH_STREAMS_FAILED,
  FETCHING_SEARCH_GROUPS_REQUEST, FETCHING_SEARCH_GROUPS_SUCCEEDED, FETCHING_SEARCH_GROUPS_FAILED,
  INVALIDATE_STREAM_ASSETS_SEARCH
} from 'constants/actionTypes.jsx';

import { call, put, takeEvery, select, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { createAction } from 'redux-actions';
import _ from 'lodash';
import buildUrl from 'build-url';

const cleverstoryApiUrl = process.env.REACT_APP_CLEVERSTORY_API_URL;
const paperfliteApiUrl = process.env.REACT_APP_PAPERFLITE_API_URL;

const STREAMS_BASE_URL = `${paperfliteApiUrl}/api/2.0/streams`;
const STREAMS_BASE_URL_NEW = `${paperfliteApiUrl}/api/2.2/streams`;
const HUB_STREAMS_URL = `${STREAMS_BASE_URL}/hub`;
const GROUP_BASE_URL = `${paperfliteApiUrl}/api/2.0/groups`;
const SEARCH_BASE_URL = `${paperfliteApiUrl}/api/2.0/search`;
const SEARCH_ASSETS_BASE_URL = `${SEARCH_BASE_URL}/assets`;
const SEARCH_STREAMS_BASE_URL = `${SEARCH_BASE_URL}/streams`;
const SEARCH_GROUPS_BASE_URL = `${SEARCH_BASE_URL}/groups`;
/*
* Fetch hub streams
*/
export const fetchHubStreamsRequest = createAction(FETCHING_HUB_STREAMS_REQUEST);

export const fetchingHubStreamsSucceeded = createAction(FETCHING_HUB_STREAMS_SUCCEEDED, (response) => {
  return {
    response: response
  }
})

const fetchingHubStreamsFailed = createAction(FETCHING_HUB_STREAMS_FAILED, (error) => {
  return {
    error: error,
  }
})

function* fetchHubStreams() {

  const fetchingHubStreamsAPI = () => {
    return axios.get(HUB_STREAMS_URL).then(response => response.data);
  }

  try {
    const response = yield call(fetchingHubStreamsAPI);
    if (response) {
      yield put(fetchingHubStreamsSucceeded(response));
    }
  } catch (error) {
    yield put(fetchingHubStreamsFailed(error));
  }
}


/*
* Fetch stream
*/
export const fetchStreamRequest = createAction(FETCHING_STREAM_REQUEST, (request, page) => {
  return {
        request: request,
        page: page,
       }
})

export const fetchingStreamSucceeded = createAction(FETCHING_STREAM_SUCCEEDED, (response, id) => {
  return {
    response: response,
    id: id
  }
})

export const fetchingStreamFailed = createAction(FETCHING_STREAM_FAILED, (error, id) => {
  return {
    error: error,
    id: id
  }
})


function* fetchStream(action) {
  const { id, limit, sort, type, callback } = action.payload.request;
  const page = action.payload.page

  let url = buildUrl(STREAMS_BASE_URL_NEW, {
    path: `/${id}/children?page=${page}&limit=${limit}&sort=${sort}&type=${type}`,
  });

  const fetchingStreamAPI = () => {
    return axios.get(url).then(response => response.data);
  }

  try {
    const response = yield call(fetchingStreamAPI);

    if (response) {
      yield put(fetchingStreamSucceeded(response, id));
    }
  } catch (error) {
    yield put(fetchingStreamFailed(error, id));
  }
}

/*
* Fetch group
*/
export const fetchGroupRequest = createAction(FETCHING_GROUP_REQUEST, (id)=> {
  return {
    id: id
  }
})

export const fetchingGroupSucceeded = createAction(FETCHING_GROUP_SUCCEEDED, (response, id)=> {
  return {
    response: response,
    id: id
  }
})

export const fetchingGroupFailed = createAction(FETCHING_GROUP_FAILED, (error, id)=> {
  return {
    error: error,
    id: id
  }
})

function* fetchGroup(action) {
  const {id, callback} = action.payload;

  let url = buildUrl(GROUP_BASE_URL, {
    path: `/${id}`
  });

  const fetchingGroupsAPI = () => {
    return axios.get(url).then(response => response.data);
  }

  try {
    const response = yield call(fetchingGroupsAPI);

    if(response) {
      yield put(fetchingGroupSucceeded(response, id));
    }
  } catch (error) {
    yield put(fetchingGroupFailed(error, id));
  }
}

export const uploadStreamAsset = createAction(UPLOAD_ASSET_REQUEST, (asset)=>{
  return {
    asset: asset
  }
})

export const invalidateStream = createAction(INVALIDATE_STREAM);

export const invalidateGroup = createAction(INVALIDATE_GROUP);

export const invalidateStreamAssetsSearch = createAction(INVALIDATE_STREAM_ASSETS_SEARCH);

/*
* Search assets within a stream
*/
export const searchStreamAssetsRequest = createAction(FETCHING_STREAM_ASSETS_SEARCH_REQUEST, (request, page) => {
  return {
    request: request,
    page: page,
  }
});

export const searchStreamAssetsSucceeded = createAction(FETCHING_STREAM_ASSETS_SEARCH_SUCCEEDED, (response, searchScopeKey, query) => {
  return {
    response: response,
    searchScopeKey: searchScopeKey,
    query: query,
  }
});

export const searchStreamAssetsFailed = createAction(FETCHING_STREAM_ASSETS_SEARCH_FAILED, (error, searchScopeKey) => {
  return {
    error: error,
    searchScopeKey: searchScopeKey,
  }
});

function* searchStreamAssets(action) {
  const { streamId, query, limit, searchWithinHub } = action.payload.request;
  const page = action.payload.page;
  const searchScopeKey = streamId || 'hub';

  const url = buildUrl(SEARCH_ASSETS_BASE_URL, {
    path: `/${page}`,
  });

  const params = {
    query: query,
    limit: limit || 24,
    highlight: false,
  };

  if (streamId) {
    params.streams = streamId;
    params.searchWithinHub = false;
  } else {
    params.searchWithinHub = searchWithinHub !== false;
  }

  const searchStreamAssetsAPI = () => {
    return axios.get(url, { params }).then(response => response.data);
  }

  try {
    const response = yield call(searchStreamAssetsAPI);

    if (response) {
      yield put(searchStreamAssetsSucceeded(response, searchScopeKey, query));
    }
  } catch (error) {
    yield put(searchStreamAssetsFailed(error, searchScopeKey));
  }
}

export const searchHubStreamsRequest = createAction(FETCHING_SEARCH_STREAMS_REQUEST, (request, page) => {
  return {
    request: request,
    page: page,
  }
});

export const searchHubStreamsSucceeded = createAction(FETCHING_SEARCH_STREAMS_SUCCEEDED, (response, searchScopeKey, query) => {
  return {
    response: response,
    searchScopeKey: searchScopeKey,
    query: query,
  }
});

export const searchHubStreamsFailed = createAction(FETCHING_SEARCH_STREAMS_FAILED, (error, searchScopeKey) => {
  return {
    error: error,
    searchScopeKey: searchScopeKey,
  }
});

function* searchHubStreams(action) {
  const { query, limit, searchScopeKey } = action.payload.request;
  const page = action.payload.page;
  const scopeKey = searchScopeKey || 'hub';

  const url = buildUrl(SEARCH_STREAMS_BASE_URL, {
    path: `/${page}`,
  });

  const searchHubStreamsAPI = () => {
    return axios.get(url, {
      params: {
        query: query,
        limit: limit || 24,
        highlight: false,
      },
    }).then(response => response.data);
  }

  try {
    const response = yield call(searchHubStreamsAPI);

    if (response) {
      yield put(searchHubStreamsSucceeded(response, scopeKey, query));
    }
  } catch (error) {
    yield put(searchHubStreamsFailed(error, scopeKey));
  }
}

export const searchStreamGroupsRequest = createAction(FETCHING_SEARCH_GROUPS_REQUEST, (request, page) => {
  return {
    request: request,
    page: page,
  }
});

export const searchStreamGroupsSucceeded = createAction(FETCHING_SEARCH_GROUPS_SUCCEEDED, (response, searchScopeKey, query) => {
  return {
    response: response,
    searchScopeKey: searchScopeKey,
    query: query,
  }
});

export const searchStreamGroupsFailed = createAction(FETCHING_SEARCH_GROUPS_FAILED, (error, searchScopeKey) => {
  return {
    error: error,
    searchScopeKey: searchScopeKey,
  }
});

function* searchStreamGroups(action) {
  const { streamId, query, limit } = action.payload.request;
  const page = action.payload.page;

  const url = buildUrl(SEARCH_GROUPS_BASE_URL, {
    path: `/${page}`,
  });

  const searchStreamGroupsAPI = () => {
    return axios.get(url, {
      params: {
        query: query,
        streams: streamId,
        limit: limit || 24,
        highlight: false,
      },
    }).then(response => response.data);
  }

  try {
    const response = yield call(searchStreamGroupsAPI);

    if (response) {
      yield put(searchStreamGroupsSucceeded(response, streamId, query));
    }
  } catch (error) {
    yield put(searchStreamGroupsFailed(error, streamId));
  }
}

export const runPaperfliteSearch = createAction('RUN_PAPERFLITE_SEARCH', (request) => {
  return { request };
});

function* runPaperfliteSearchSaga(action) {
  const { streamId, query, limit, searchWithinHub } = action.payload.request;
  const searchRequest = {
    streamId,
    query,
    limit: limit || 24,
    searchWithinHub,
  };

  yield put(searchStreamAssetsRequest(searchRequest, 0));

  if (streamId) {
    yield put(searchStreamGroupsRequest({ streamId, query, limit: limit || 24 }, 0));
  } else {
    yield put(searchHubStreamsRequest({
      query,
      limit: limit || 24,
      searchScopeKey: 'hub',
    }, 0));
  }
}


export default function* paperfliteSaga() {
  yield takeLatest(FETCHING_HUB_STREAMS_REQUEST, fetchHubStreams);
  yield takeEvery(FETCHING_STREAM_REQUEST, fetchStream);
  yield takeLatest(FETCHING_STREAM_ASSETS_SEARCH_REQUEST, searchStreamAssets);
  yield takeLatest(FETCHING_SEARCH_STREAMS_REQUEST, searchHubStreams);
  yield takeLatest(FETCHING_SEARCH_GROUPS_REQUEST, searchStreamGroups);
  yield takeLatest('RUN_PAPERFLITE_SEARCH', runPaperfliteSearchSaga);
  yield takeEvery(UPLOAD_ASSET_REQUEST, uploadStreamAsset);
  yield takeEvery(FETCHING_GROUP_REQUEST, fetchGroup);
};
